import { createFileRoute } from '@tanstack/react-router';
import { McpRevealPage } from '../features/mcp/reveal-page';

function McpRevealRoute() {
  const { id } = Route.useParams();
  return <McpRevealPage id={id} />;
}

export const Route = createFileRoute('/account/mcp/reveal/$id')({
  component: McpRevealRoute,
});
